import { assertIsSettableValueState, DerivedValueState, isDerivedValue, PrimitiveValueState, } from "./state/index.js";
export class Store {
    #options;
    #values = new Map();
    #createValue = (value) => {
        if (isDerivedValue(value)) {
            return new DerivedValueState(value, () => {
                this.#removeValue(value);
            }, (dependency) => this.#getDependency(dependency), this.#options.defaultRemovalSchedule);
        }
        return new PrimitiveValueState(value, () => {
            this.#removeValue(value);
        }, this.#options.defaultRemovalSchedule);
    };
    #removeValue = (value) => {
        this.#values.delete(value.name);
    };
    #getDependency = (value) => {
        if (!this.#values.has(value.name)) {
            this.#values.set(value.name, this.#createValue(value));
        }
        return this.#values.get(value.name);
    };
    constructor(options = {}) {
        this.#options = {
            defaultRemovalSchedule: { schedule: "synchronous" },
            ...options,
        };
    }
    getValue = this.#getDependency;
    getActor(action) {
        return (...args) => {
            action({
                get: (value) => this.#getDependency(value).current,
                set: (value, entry) => {
                    const valueState = this.#getDependency(value);
                    assertIsSettableValueState(valueState);
                    valueState.set(entry);
                },
            }, ...args);
        };
    }
    hasValue(value) {
        return this.#values.has(value.name);
    }
}
//# sourceMappingURL=store.js.map